import { render } from "./Develop_strategies.vue?vue&type=template&id=ca305b54&scoped=true"
import script from "./Develop_strategies.vue?vue&type=script&lang=js"
export * from "./Develop_strategies.vue?vue&type=script&lang=js"

import "./Develop_strategies.vue?vue&type=style&index=0&id=ca305b54&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca305b54"]])

export default __exports__